import React from 'react'
import {makeStyles, TableBody, TableCell, TableHead, TableRow} from '@material-ui/core';
import PropTypes from 'prop-types';
import Tr from 'translations/Translations';
import clsx from "clsx";
import Table from "@material-ui/core/Table";
import SiwzVersionsTableRow from "./SiwzVersionsTableRow";

const useStyle = makeStyles(theme => ({
    cell: {
        padding: theme.spacing(1),
    },
    buttonColumn: theme.components.table.buttonColumn,
    dateColumn: theme.components.table.dateColumn,
    versionColumn: {
        width: 70
    },
    typeColumn: {
        width: 180
    }
}));

function SiwzVersionsTable(
    {
        demandId,
        rootRowIdentity,
        versions,
        onOpenDownloadHistory,
        onEditDescriptionFile,
        showShare,
    }) {

    const classes = useStyle();

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell className={classes.cell}>{Tr("name")}</TableCell>
                    <TableCell className={clsx(classes.cell, classes.buttonColumn)}>{Tr("description")}</TableCell>
                    <TableCell className={clsx(classes.cell, classes.typeColumn)}>{Tr("type")}</TableCell>
                    <TableCell className={clsx(classes.cell, classes.versionColumn)}>{Tr("version")}</TableCell>
                    <TableCell className={clsx(classes.cell, classes.dateColumn)}>{Tr("add_data")}</TableCell>
                    <TableCell className={clsx(classes.cell, classes.dateColumn)}>{Tr("publish_data")}</TableCell>
                    <TableCell className={clsx(classes.cell, classes.buttonColumn)}></TableCell>
                    {showShare && <TableCell className={clsx(classes.cell, classes.buttonColumn)}></TableCell>}
                    <TableCell className={clsx(classes.cell, classes.buttonColumn)}></TableCell>
                    <TableCell className={clsx(classes.cell, classes.buttonColumn)}></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {
                    versions.map((doc) => (
                        <SiwzVersionsTableRow
                            key={doc.source + "_" + doc.identity}
                            demandId={demandId}
                            rootRowIdentity={rootRowIdentity}
                            row={doc}
                            onEditDescriptionFile={onEditDescriptionFile}
                            onOpenDownloadHistory={onOpenDownloadHistory}
                            showShare={showShare}
                        />
                    ))
                }
            </TableBody>

        </Table>
    )
}

SiwzVersionsTable.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    rootRowIdentity: PropTypes.number.isRequired,
    versions: PropTypes.arrayOf(PropTypes.shape({
        identity: PropTypes.number.isRequired,
        source: PropTypes.string.isRequired
    })).isRequired,
    onOpenDownloadHistory: PropTypes.func.isRequired,
    onEditDescriptionFile: PropTypes.func.isRequired,
    showShare: PropTypes.bool.isRequired,
};

export default SiwzVersionsTable;